import type { TenantCustomization } from './types';
import { hitowaCustomization } from './hitowa';

/**
 * Tenant customization registry.
 *
 * Adding a site type is: create `customize/<code>/`, export a
 * `TenantCustomization`, add one line here. No file under `src/` changes.
 */
const registry: Record<string, TenantCustomization> = {
  [hitowaCustomization.code]: hitowaCustomization,
};

/** Customization for a site type, or `undefined` when it has none. */
export function getTenantCustomization(siteType?: string): TenantCustomization | undefined {
  if (!siteType) return undefined;
  const found = registry[siteType.toLowerCase()];
  return found?.enabled ? found : undefined;
}

/** Every enabled customization. Used to build the core registries at startup. */
export function getTenantCustomizations(): TenantCustomization[] {
  return Object.values(registry).filter(t => t.enabled);
}

/** Site types that ship a customization bundle. */
export function getCustomizedSiteTypes(): string[] {
  return getTenantCustomizations().map(t => t.code);
}

export type { TenantCustomization };
